import {useMutation, useSuspenseQuery} from '@tanstack/react-query';

import {createPapasTransaction, getRecommendCardIntro} from '@/root/apis/recommend';
import {RecommendCodeUsingPapas} from '@/root/constants/recommendCode';
import {isRecommendCode} from '@/root/utils/recommendCode';

import RecommendCodeError from '@/shared/errors/RecommendCodeError';
import useAbortSignalOnUnmount from '@/shared/hooks/useAbortSignalOnUnmount';

export const recommendKeys = {
  all: ['recommend'] as const,
  intro: (recommendCode: string) => [...recommendKeys.all, recommendCode]
};

export const useRecommendCardIntro = (recommendCode: string) => {
  const {data: cardIntro} = useSuspenseQuery({
    queryKey: recommendKeys.intro(recommendCode),
    queryFn: async () => {
      if (!isRecommendCode(recommendCode)) {
        throw new RecommendCodeError(recommendCode);
      }

      const {cardIntro} = await getRecommendCardIntro(recommendCode);
      return cardIntro;
    }
  });

  return {cardIntro};
};

export const useCreatePapasTransaction = () => {
  const signal = useAbortSignalOnUnmount();

  const createPapasTransactionMutation = useMutation({
    mutationFn: (code: RecommendCodeUsingPapas) => createPapasTransaction(code, {signal}),
    throwOnError: false
  });

  return {createPapasTransactionMutation};
};
